import { AppReducer } from './app-reducer';
import { InitialState } from '../state';

export const SierraDeviceReducer: AppReducer<'SierraDevice'> = (
    state = InitialState.SierraDevice,
    action
): typeof state => {
    switch (action.type) {
        case 'SierraGatewayDevice/Registration/Started':
            return {
                ...state,
                gatewayLoading: true,
                gatewaySuccess: false,
            };

        case 'SierraGatewayDevice/Registration/Succeeded':
            return {
                ...state,
                gatewayLoading: false,
                gatewaySuccess: true,
                selectedChildDevices: action.payload.childDevices,
            };

        case 'SierraGatewayDevice/Registration/Failed':
            return {
                ...state,
                gatewayLoading: false,
                gatewaySuccess: false,
                errorCode: action.payload.errorCode,
            };
        case 'SierraGatewayDevice/Registration/Unmounted':
            return {
                ...state,
                gatewayLoading: false,
                gatewaySuccess: false,
                loading: false,
                success: false,
                errorCode: '',
                selectedChildDevices: [],
            };

        case 'SierraChildDevice/Registration/Started':
            return {
                ...state,
                loading: true,
                success: false,
            };

        case 'SierraChildDevice/Registration/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,
            };

        case 'SierraChildDevice/Registration/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                errorCode: action.payload.errorCode,
            };
        case 'SierraChildDevice/Registration/Unmounted':
            return {
                ...state,
                gatewayLoading: false,
                gatewaySuccess: false,
                loading: false,
                success: false,
                errorCode: '',
                deleteChildDeviceLoading: false,
                deleteChildDeviceSuccess: false,
                deleteSuccess: false,
            };
        case 'SierraGatewayDevice/MasterData/Failed':
            return {
                ...state,
                hasData: action.payload.hasData,
            };
        case 'SierraChildDevice/UnitIdValidation/exertherm':
            return {
                ...state,
                loading: false,
                exerthermUnitIdValidation: action.payload.unitIdValidation,
            };
        case 'SierraGatewayDevice/Update/Started':
            return {
                ...state,
                gatewayLoading: true,
                gatewaySuccess: false,
            };

        case 'SierraGatewayDevice/Update/Succeeded':
            return {
                ...state,
                gatewayLoading: false,
                gatewaySuccess: true,
            };

        case 'SierraGatewayDevice/Update/Failed':
            return {
                ...state,
                gatewayLoading: false,
                gatewaySuccess: false,
                errorCode: action.payload.errorCode,
            };
        case 'SierraGatewayDevice/Update/Reset':
            return {
                ...state,
                gatewayLoading: false,
                gatewaySuccess: false,
            };
        case 'SierraChildDevice/Update/Started':
            return {
                ...state,
                loading: true,
                success: false,
            };

        case 'SierraChildDevice/Update/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,
            };

        case 'SierraChildDevice/Update/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                errorCode: action.payload.errorCode,
            };
        case 'Device/Delete/Succeeded':
            return {
                ...state,
               deleteSuccess: true,
               deleteMessage: action.payload.message,
            };

        case 'Device/Delete/Failed':
            return {
                ...state,
                deleteSuccess: false,
                errorCode: action.payload.errorCode,
            };
        

        case 'SierraChildDevice/Delete/Started':
            return {
                ...state,
                deleteChildDeviceLoading: true,
                deleteChildDeviceSuccess: false,
            };

        case 'SierraChildDevice/Delete/Succeeded':
            return {
                ...state,
                deleteChildDeviceLoading: true,
                deleteChildDeviceSuccess: true,
            };

        case 'SierraChildDevice/Delete/Failed':
            return {
                ...state,
                deleteChildDeviceLoading: false,
                deleteChildDeviceSuccess: false,
                errorCode: action.payload.errorCode,
            };

        default:
            return state;
    }
};
